import { authApiUrl, apiUrl } from 'src/config'

export {
  AUTH_ENDPOINTS,
  USER_ENDPOINTS,
  AUTHS_ENDPOINTS,
  TICKET_ENDPOINTS,
  PRODUCT_ENDPOINTS,
  FCM_ENDPOINTS,
  ENDPOINTS_OUTSIDE_VUE_QUERY,
  SUPPORT_ENDPOINTS,
  INTEGRATION_ENDPOINTS,
  STORAGE_KEYS,
  API_ERRORS,
  ANALYTICS_EVENTS,
  AUTH_FLOW_APP,
  AUTH_FLOW_REASONS,
  ERROR_TYPES,
}

const AUTH_ENDPOINTS = {
  AUTH0_LOGIN: authApiUrl + '/auth0_login',
  LOAD_ACCOUNT: apiUrl + '/load_account',
  LOAD_POLICIES: apiUrl + '/load_wb_lists',
  LOGOUT: apiUrl + '/logout',
}

const USER_ENDPOINTS = {
  LOGIN_SYNC: apiUrl + '/user/user_login_sync',
  UPDATE_SETTINGS: apiUrl + '/user/update_preferences',
  NOTIFICATION_PREFERENCES_GET: apiUrl + '/user/notification_preferences/get',
  NOTIFICATION_PREFERENCES_UPDATE: apiUrl + '/user/notification_preferences/update',
  USER_FUNCTIONS: apiUrl + '/user/functions',
}

const AUTHS_ENDPOINTS = {
  GET_AUTH_BY_ID: apiUrl + '/auths/get_user_auth',
  REVOKE_AUTH: apiUrl + '/auths/revoke',
  APPROVE_AUDIT: apiUrl + '/audit/approve',
}

const TICKET_ENDPOINTS = {
  GET_TICKET_BY_ID: apiUrl + '/ticket/get',
  MESSAGES: apiUrl + '/ticket/messages',
  CREATE_TICKET: apiUrl + '/ticket/new',
  UPDATE_TICKET: apiUrl + '/ticket/update',
  FILE_UPLOAD: apiUrl + '/ticket/file_upload',
  FILE_DELETE: apiUrl + '/ticket/file_delete',
  FILE_GET_LINK: apiUrl + '/ticket/file_get_link',
}

const PRODUCT_ENDPOINTS = {
  SEARCH_COMPANY: apiUrl + '/company/search',
  SEARCH_PRODUCTS: apiUrl + '/company/get_products',
}

const FCM_ENDPOINTS = {
  UPDATE_TOKEN: apiUrl + '/fcm/update_token',
}

// Requests made outside Vue Query (no query/mutation cache sees them), so the
// response interceptor must report their no-response errors itself.
const ENDPOINTS_OUTSIDE_VUE_QUERY = [
  AUTH_ENDPOINTS.LOGOUT,
  USER_ENDPOINTS.LOGIN_SYNC,
  FCM_ENDPOINTS.UPDATE_TOKEN,
]

const SUPPORT_ENDPOINTS = {
  NEW_TICKET: apiUrl + '/zendesk/new_ticket',
}

const INTEGRATION_ENDPOINTS = {
  USER_INFO_GET: apiUrl + '/integrations/slack/user_info_get',
  USER_ENABLE: apiUrl + '/integrations/slack/user_enable',
  USER_DISABLE: apiUrl + '/integrations/slack/user_disable',
  SEND_TEST_MESSAGE: apiUrl + '/integrations/slack/send_test_message',
}

const STORAGE_KEYS = {
  LOGGED_IN_USER: 'LOGGED_IN_USER',
  REDIRECT_ROUTE: 'REDIRECT_ROUTE',
  AUTH0_LOGIN_CACHE: 'AUTH0_LOGIN_CACHE',
  FCM_TOKEN_CACHE: 'FCM_TOKEN_CACHE',
  // Session storage: the walkthrough was skipped for this sign-in. Logout clears it.
  ONBOARDING_TOUR_SNOOZED: 'ONBOARDING_TOUR_SNOOZED',
  VERSION_CONTROL_ID: 'VERSION_CONTROL_ID',
  // Literal string is duplicated in index.html's pre-mount script — keep both in sync
  THEME_PREFERENCE: 'THEME_PREFERENCE',
}

const API_ERRORS = {
  AUTH_EXPIRED: 'Authentication Expired',
  AUTH_ERROR: 'Authentication Error',
  UNAUTHORIZED: 'Unauthorized',
  REQ_ERROR: 'API Request Error',
  NETWORK_ERROR: 'Network Error',
  CORS_ERROR: 'CORS Error',
  LOGOUT_AUTH_ERROR: 'Logout AUTH0 Error',
  LOGIN_AUTH_ERROR: 'Login AUTH0 Error',
  PRACTICE_ID_BLOCKED: 'Walkthrough Example Blocked',
}

const ANALYTICS_EVENTS = {
  ENTITY_SEARCH: 'entity_search',
  FCM_PERMISSION_DENIED: 'fcm_permission_denied',
  FCM_NOT_SUPPORTED: 'fcm_not_supported',
  ONBOARDING_TOUR_STARTED: 'onboarding_tour_started',
  ONBOARDING_TOUR_DONE: 'onboarding_tour_done',
  ONBOARDING_TOUR_SKIPPED: 'onboarding_tour_skipped',
  ONBOARDING_TOUR_SNOOZED: 'onboarding_tour_snoozed',
  SENT_TO_SIGN_IN: 'Sent to sign-in',
  SIGNED_OUT: 'Signed out',
  SIGNED_OUT_SERVER_REJECTED: 'Signed out, server rejected session',
  SIGNED_OUT_COULD_NOT_REFRESH: 'Signed out, session could not refresh',
  SIGNED_OUT_SIGN_IN_ERROR: 'Signed out, sign-in error',
  REFRESHED_SESSION_EARLY: 'Refreshed the session early',
  REFRESH_TOKEN_NOT_USABLE: 'Refresh gave back a token we would not use',
  REFRESH_FAILED: 'Refresh failed',
  SERVER_RETURNED_AN_ERROR: 'Server returned an error',
  SERVER_DID_NOT_RESPOND: 'Server did not respond',
}

const AUTH_FLOW_APP = 'aigov'

// Sign-out event title -> `reason` query param on the auth router URL
const AUTH_FLOW_REASONS = {
  [ANALYTICS_EVENTS.SIGNED_OUT]: 'signed_out',
  [ANALYTICS_EVENTS.SIGNED_OUT_SERVER_REJECTED]: 'server_rejected',
  [ANALYTICS_EVENTS.SIGNED_OUT_COULD_NOT_REFRESH]: 'could_not_refresh',
  [ANALYTICS_EVENTS.SIGNED_OUT_SIGN_IN_ERROR]: 'sign_in_error',
}

// Used for both [bracket prefix] in error_name AND error_type (Error.name in PostHog)
const ERROR_TYPES = {
  API: 'API Request Error',
  AUTH: 'Authentication Error',
  VUE: 'Vue Error',
  QUERY: 'Query Error',
  MUTATION: 'Mutation Error',
  FCM: 'FCM Error',
  FIREBASE: 'Firebase Error',
  UNCAUGHT: 'Uncaught Error',
  VERSION_MISMATCH: 'VersionMismatchError',
  OFFLINE: 'OfflineError',
}
